import React from "react";
import { Button, CircularProgress } from "@mui/material";
import styles from "./Buttons.module.scss";

const TertiaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  className,
  ...props
}) => {
  const buttonClassName = [styles.buttonBase, styles.tertiaryButton, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      variant="contained"
      color="error"
      disabled={isLoading || disabled}
      disableElevation
      startIcon={isLoading ? undefined : startIcon}
      className={buttonClassName}
      sx={sx}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default TertiaryButton;
